import React, { useEffect, useState, useCallback } from 'react';
import { Button, Card, Form, Input, InputNumber, message, Popconfirm, Select, Space, Spin, Table, Modal } from 'antd';
import { DeleteOutlined, EditOutlined } from '@ant-design/icons';
import { getFormattedDouble } from '../../utils/format';
import { sendRequests } from '../../requests';
import SendFormFields from '../sendFormFields/SendFormFields';
import './Send.scss';

const { Option } = Select;

const Send = ({ month, year, total, setTotal }) => {
  const [form] = Form.useForm();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [editingRecord, setEditingRecord] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [editForm] = Form.useForm();

  const fetchData = async (newMonth, newYear) => {
    const response = await sendRequests.getAllByMonthAndYear(newMonth, newYear);
    const newData = response.data.map(v => ({ ...v, total: v.quantity * v.unitValue }));
    setData(newData);
    setTotal(newData.reduce((t, a) => (t + a.total), 0));
  };

  useEffect(() => {
    fetchData(month, year);
  }, [month, year]);

  const handleCreate = async () => {
    form
      .validateFields()
      .then(async (values) => {
        const params = {
          ...values,
          unitValue: values.unitValue.replace(',', '.'),
          month,
          year,
        };
        await sendRequests.create(params);
        form.resetFields();
        fetchData(month, year);
      })
      .catch((errorInfo) => {
        console.log('Erro na validação:', errorInfo);
      });
  };

  const handleDelete = async (id) => {
    await sendRequests.delete(id);
    fetchData(month, year);
  };

  const handleEdit = (record) => {
    setEditingRecord(record);
    editForm.setFieldsValue({
      ...record,
      unitValue: record.unitValue.toString().replace('.', ','),
    });
    setIsModalVisible(true);
  };

  const handleEditSubmit = async () => {
    try {
      const values = await editForm.validateFields();
      const params = {
        ...values,
        unitValue: values.unitValue.replace(',', '.'),
        month,
        year,
      };
      // Supondo que sua API possua um endpoint PUT para atualizar
      await sendRequests.update(params, editingRecord.id);
      setIsModalVisible(false);
      setEditingRecord(null);
      fetchData(month, year);
    } catch (error) {
      console.log('Erro ao validar/atualizar:', error);
    }
  };

  const columns = [
    {
      title: 'Id',
      dataIndex: 'id',
      key: 'id',
    },
    {
      title: 'Nome',
      dataIndex: 'name',
      key: 'name',
      render: (text) => {
        switch (text) {
          case 'OMNION':
            return 'Omnion';
          case 'SC':
            return 'SC';
          case 'MARKUP':
            return 'Markup';
          case 'BANCO_SC':
            return 'Banco SC';
          default:
            return text;
        }
      },
    },
    {
      title: 'Tipo de disparo',
      dataIndex: 'sendType',
      key: 'sendType',
      render: (text) => {
        switch (text) {
          case 'WHATSAPP':
            return 'WhatsApp';
          case 'EMAIL':
            return 'Email';
          case 'SMS':
            return 'SMS';
          default:
            return text;
        }
      },
    },
    {
      title: 'Quantidade',
      dataIndex: 'quantity',
      key: 'quantity',
    },
    {
      title: 'Valor unitário',
      dataIndex: 'unitValue',
      key: 'unitValue',
      render: (text) => `R$ ${getFormattedDouble(text)}`,
    },
    {
      title: 'Total',
      key: 'total',
      sorter: (a, b) => a.total - b.total,
      render: (text, obj) => `R$ ${getFormattedDouble(obj.total)}`,
    },
    {
      title: 'Ações',
      key: 'actions',
      render: (record) => (
        <Space>
          <EditOutlined onClick={() => handleEdit(record)} style={{ cursor: 'pointer' }} />
          <Popconfirm
            title="Tem certeza que deseja excluir este registro?"
            onConfirm={() => handleDelete(record.id)}
            okText="Sim"
            cancelText="Não"
          >
            <DeleteOutlined style={{ cursor: 'pointer' }} />
          </Popconfirm>
        </Space>
      ),
    },
  ];

  return (
    <div className="Send">
      <Spin tip="Carregando" spinning={loading}>
        <Card title="Cadastrar novo" style={{ margin: '20px 0' }}>
          <Form form={form} autoComplete="off" layout="vertical" className="form-container">
            <SendFormFields />
            <Form.Item style={{ display: 'flex', flexDirection: 'column-reverse' }}>
              <Button type="primary" onClick={handleCreate}>
                Adicionar
              </Button>
            </Form.Item>
          </Form>
        </Card>

        <Table columns={columns} dataSource={data} pagination={false} />

        <Modal
          title="Editar Envio"
          visible={isModalVisible}
          onOk={handleEditSubmit}
          onCancel={() => { setIsModalVisible(false); setEditingRecord(null); }}
          okText="Salvar"
          cancelText="Cancelar"
        >
          <Form form={editForm} layout="vertical" autoComplete="off">
            <SendFormFields />
          </Form>
        </Modal>
      </Spin>
    </div>
  );
};

export default Send;
